import OverleafStore from "../stores/overleaf-store";
import Dispatcher from "../dispatcher";

export default {
  setProficiency(card, proficiency) {
    Dispatcher.emit(Dispatcher.OVERLEAF_SET_PROFICIENCY, card, proficiency);
  },

  setConfidence(card, confidence) {
    switch (confidence) {
      case OverleafStore.CONFIDENCE.CONFIDENT:
        this.setProficiency(card, 100);
        break;
      case OverleafStore.CONFIDENCE.NEUTRAL:
        this.setProficiency(card, 50);
        break;
      case OverleafStore.CONFIDENCE.NOT_CONFIDENT:
        this.setProficiency(card, 0);
        break;
    }
  }
};
